
document.addEventListener('DOMContentLoaded', function () {

  const sliders = document.querySelectorAll('.mv-swiper');

  sliders.forEach((slider, i) => {

    new Swiper(slider, {
      loop: true,
      speed: 600,
      effect: "fade",
      fadeEffect: {
          crossFade: true,
      },
      slidesPerView: 1,
      spaceBetween: 0,

      navigation: {
        nextEl: slider.closest('.imglist').querySelector('.detail-main-next'),
        prevEl: slider.closest('.imglist').querySelector('.detail-main-prev'),
      },

    });

  });

});
